import React from 'react';
import useSWR from 'swr';
import fetcher from '../../utils/fetcher';
import { NavLink, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import moment from 'moment';
import 'moment/locale/ko';
import { Helmet } from 'react-helmet';
import './style.css'

const PressDetail = () => {
  const { dt } = useParams();
  const { data: pressData } = useSWR(`https://api.testworks.co.kr/press-releases/${dt}`, fetcher);
  const targetWord = '\n\n';
  const replaceWord = '&NewLine;';

  if (!pressData) return null;

  return (
    <>
      <Helmet>
        <title>{pressData.title}</title>
        <meta name='description' content='에이아이웍스의 뉴스 및 발표와 관련된 기사 및 보도자료를 살펴보세요.' />
        <link rel='stylesheet' href='whitegnb.css' />
      </Helmet>
      <section className='press-detail'>
        <section className='visual_wrap_short'>
          <span className='line'></span>
          <div className='inner'>
            <div className='header'>
              <h2>Press Release</h2>
            </div>
          </div>
        </section>
        <div className='inner'>
          <div className='detail-body'>
            <div className='date'>{moment(pressData.set_day).format('YYYY년 MM월 DD일')}</div>
            <div className='title'>
              <h2>{pressData.title}</h2>
              <span>{pressData.preview}</span>
            </div>
            <div className='body'>
              <ReactMarkdown remarkPlugins={[remarkBreaks, remarkGfm]}>{pressData.body.replace(new RegExp(targetWord, 'g'), replaceWord)}</ReactMarkdown>
            </div>
            <NavLink to='/pressroom' style={{ textDecoration: 'none' }}>
              <button className='tolist-btn'>목록보기</button>
            </NavLink>
          </div>
          <div className='related-articles'>
            <h2>관련기사</h2>
            <a href={pressData.articleurl1}>{pressData.articlename1}</a>
            <a href={pressData.articleurl2}>{pressData.articlename2}</a>
            <a href={pressData.articleurl3}>{pressData.articlename3}</a>
          </div>
        </div>
      </section>
    </>
  )
}

export default PressDetail;